export default __webpack_public_path__ + "static/media/club4.220f7a3e.webp";